import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@/components/ui/table';
import { Fragment } from 'react/jsx-runtime';
import { Category } from './budget-data';
import { useCurrencyFormatter } from '@liquidbudget/common';

type Props = {
  categories: Category[];
};

export function BudgetTable({ categories }: Props) {
  const formatCurrency = useCurrencyFormatter();

  const getTotalAssigned = (item: Category) => {
    return item.buckets.reduce((sum, bucket) => sum + bucket.assigned, 0);
  };

  const getTotalOutflow = (item: Category) => {
    return item.buckets.reduce((sum, bucket) => sum + (bucket?.outflow || 0), 0);
  };

  const getTotalAvailable = (item: Category) => {
    return item.buckets.reduce((sum, bucket) => sum + (bucket.assigned + (bucket?.outflow || 0)), 0);
  };

  return (
    <Table className="bg-white dark:bg-gray-800  md:text-base text-sm">
      <TableHeader>
        <TableRow>
          <TableCell className="font-bold">Category</TableCell>
          <TableCell className="text-right font-bold pr-5">Assigned</TableCell>
          <TableCell className="text-right font-bold pr-5">Outflow</TableCell>
          <TableCell className="text-right font-bold pr-4">Available</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {categories.map((category) => (
          <Fragment key={category.id}>
            <TableRow key={category.id} className="bg-accent ">
              <TableCell className="font-semibold">{category.name}</TableCell>
              <TableCell className="font-semibold text-right pr-5">
                {formatCurrency(getTotalAssigned(category))}
              </TableCell>
              <TableCell className="font-semibold text-right pr-5">
                {formatCurrency(getTotalOutflow(category))}
              </TableCell>
              <TableCell className="font-semibold text-right pr-4">
                {formatCurrency(getTotalAvailable(category))}
              </TableCell>
            </TableRow>
            {category.buckets.map((bucket) => (
              <TableRow key={bucket.id} className="bg-white dark:bg-black/50">
                <TableCell className=" p-1 pl-2 ">{bucket.name}</TableCell>
                <TableCell className="text-right p-1">
                  <div className="h-8 flex items-center justify-end text-md text-slate-600 pr-4">
                    {formatCurrency(bucket.assigned)}
                  </div>
                </TableCell>
                <TableCell className="text-right p-1">
                  <div className="h-8 flex items-center justify-end text-md text-slate-600 pr-4">
                    {formatCurrency(bucket.outflow)}
                  </div>
                </TableCell>
                <TableCell className="text-right p-1">
                  {bucket.assigned + bucket.outflow === 0 && (
                    <div className="h-8 flex items-center justify-end  text-md text-slate-600 pr-3 ">
                      {formatCurrency(bucket.assigned + bucket.outflow)}
                    </div>
                  )}

                  {bucket.assigned + bucket.outflow > 0 && (
                    <Button variant="active" size="sm" className="text-sm ">
                      {formatCurrency(bucket.assigned + bucket.outflow)}
                    </Button>
                  )}

                  {bucket.assigned + bucket.outflow < 0 && (
                    <Button variant="destructive" size="sm" className="text-sm ">
                      {formatCurrency(bucket.assigned + bucket.outflow)}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </Fragment>
        ))}
      </TableBody>
    </Table>
  );
}
